import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { StoreModal } from "./components/StoreModal";
import { useStoreStore } from "../../hooks/useStoreStore";
import { RoutesMap } from "../../types";
import { useImportStore } from "../../hooks/useImportStore";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'code', label: 'Cod. bodega', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align: 'center' },
    { type: 'text', field: 'status', label: 'Estado', align: 'center', format: (row) => row.status == 1 ? 'Activado' : 'Desactivado' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Bodegas', pathname: RoutesMap.WAREHOUSE }
]

export const StoreDisabledView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionStore, getStore, deleteStore, changeStatusStore } = useStoreStore();

    const [loading, setLoading] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getStoreApi()
    }, []);

    const getStoreApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getStore(search, { status: 0});
            if (!response) {
                setBranchOffices([]);
                setLoading(false);
                return false;
            } else {
                setBranchOffices(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onDelete = (rowSelected: any) => {
        setActionStore('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
  
    const onSwitch = async (rowSelected) => {
        const statusrow = rowSelected?.status == '0' ? '1' : '0';
        setLoading(true);
        const response: any = await changeStatusStore(rowSelected.id, { status: statusrow });
        if (response) {
            getStoreApi();
            setLoading(false);
            setRowSelected('');
        } else {
            setLoading(false);
            return false;
        }
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteStore(rowSelected.id)
            if (response) {
                getStoreApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getStoreApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Bodegas desactivadas'}
                    columns={columns}
                    loading={loading}
                    rows={branchOffices || []}
                    onRowClick={() => { }}
                    hasOptions
                    onDelete={onDelete}
                    onSwitch={onSwitch}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <StoreModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        storeSelected={rowSelected}
                        liststore={getStoreApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}